import React, { Component } from 'react';
import SkinsActions from "../../actions/skins.actions";
import {SkinsReducer} from "../../reducers/skins.reducer";
import {connect} from "react-redux";
import {
    Avatar,
    CircularProgress, Paper
} from "material-ui";
import { withStyles } from 'material-ui/styles';
import {
    Grid, Table, TableHeaderRow, PagingPanel, TableFilterRow, VirtualTable, TableRowDetail
} from '@devexpress/dx-react-grid-material-ui';
import {
    PagingState,
    IntegratedPaging,
    FilteringState,
    IntegratedFiltering,
    RowDetailState,
    SortingState,
    IntegratedSorting
} from '@devexpress/dx-react-grid';
import ReactGA from 'react-ga';

const styles = theme => ({
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    }
});

class Skins extends Component {

    state = {
        fetchSkins: true,
        expandedSkins: []
    };

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
        SkinsActions.get().on('value', data => {
            let dataObj = data.val();
            let aaa = dataObj['MAN'];
            let fakeE = document.createElement('html');
            //Get content of each elements
            fakeE.innerHTML = aaa;
            let arr = [].slice.call(fakeE.querySelectorAll('table.listskin td'));
            let finalArray = [];
            arr.map(a => {
                let nV = a.querySelectorAll('center');
                let skin = {
                    name: nV[0].lastChild.textContent,
                    img: [].slice.call(nV[0].querySelectorAll('img'))[0].src,
                    gender: 'Homme'
                };
                finalArray.push(skin);
            });
            this.props.dispatch(SkinsReducer.set(finalArray));
            this.setState({fetchSkins: false});
        })
    }

    render() {
        return (
            <div>
                <h1>Liste des skins libres</h1>
                {this.state.fetchSkins &&
                <div style={{textAlign: 'center'}}>
                    <CircularProgress/>
                </div>
                }

                {!this.state.fetchSkins &&
                <Paper elevation={4} style={{padding: '16px', marginTop: '16px'}}>
                    <Grid
                        rows={this.props.skins}
                        columns={[
                            {name: 'name', title: 'Nom de la skin'},
                            {name: 'gender', title: 'Type'}
                        ]}
                    >
                        <RowDetailState
                            defaultExpandedRowIds={[]}
                        />

                        <FilteringState defaultFilters={[]} />
                        <SortingState
                            defaultSorting={[
                                { columnName: 'name', direction: 'asc' }
                            ]}
                        />
                        <PagingState
                            defaultCurrentPage={0}
                            pageSize={20}
                        />

                        <IntegratedFiltering rows={this.props.skins} />
                        <IntegratedSorting />
                        <IntegratedPaging />
                        <VirtualTable
                            cellComponent={this.renderCell}
                        />
                        <TableHeaderRow showSortingControls />
                        <TableRowDetail
                            contentComponent={this.renderDetail}
                        />
                        <PagingPanel />
                        <TableFilterRow
                            messages={{
                                filterPlaceholder: 'Recherche...'
                            }}
                        />
                    </Grid>
                </Paper>
                }
            </div>
        )
    }

    renderCell = props => {
        if(props.column.name === 'name'){
            return <VirtualTable.Cell value={this.renderCellName(props.row)} />;
        } else {
            return <VirtualTable.Cell {...props} />
        }
    };


    renderCellName = row => {
        return (
            <span style={{display:'flex', alignItems: 'center'}}>
                <Avatar src={row.img} style={{marginRight: '16px', width: '30px', height:'30px'}}/> {row.name}
            </span>
        )
    };

    renderDetail = props => {
        let chipset = `http://chipset.slayersonline.net/${props.row.name}.png`;
        return (
            <img src={encodeURI(chipset)}/>);
    };
}

const state2props = state => ({
    skins: state.Skins.skins
});

export default connect(state2props)(withStyles(styles)(Skins));


// WEBPACK FOOTER //
// ./src/pages/skins/Skins.js